// extracted by mini-css-extract-plugin
module.exports = {"icon":"Taxi_icon__11Scl","item":"Taxi_item__2Ud6Z","head":"Taxi_head__2nYjq","titleInfoTaxi":"Taxi_titleInfoTaxi__3XEKJ","textInfoTaxi":"Taxi_textInfoTaxi__1GGVY"};